module.exports = __webpack_public_path__ + "assets/671d58442fdce32441595f476ce2f716.mp3";